import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icons/abc.png'
import _imports_1 from '@/assets/images/icons/light.png'
import _imports_2 from '@/assets/images/logo/logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "w-full px-6"
}
const _hoisted_2 = { class: "py-12 flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl font-bold text-neutral-500 whitespace-nowrap md-down:text-xl" }, " Ngân hàng mục tiêu ", -1)
const _hoisted_4 = { class: "cursor-pointer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.71478 8.71453C9.05649 8.37282 9.61051 8.37282 9.95221 8.71453L14.5835 13.3458L19.2148 8.71453C19.5565 8.37282 20.1105 8.37282 20.4522 8.71453C20.7939 9.05624 20.7939 9.61026 20.4522 9.95197L15.8209 14.5833L20.4522 19.2145C20.7939 19.5562 20.7939 20.1103 20.4522 20.452C20.1105 20.7937 19.5565 20.7937 19.2148 20.452L14.5835 15.8207L9.95221 20.452C9.61051 20.7937 9.05649 20.7937 8.71478 20.452C8.37307 20.1103 8.37307 19.5562 8.71478 19.2145L13.3461 14.5833L8.71478 9.95197C8.37307 9.61026 8.37307 9.05624 8.71478 8.71453Z",
  fill: "#94A3B8"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "p-6 bg-white rounded-2xl" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Thống kê chung "),
    /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 text-right" })
  ])
], -1)
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2" }
const _hoisted_10 = { class: "p-6 border lg:rounded-l-lg md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none" }
const _hoisted_11 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực ")
], -1)
const _hoisted_14 = { class: "p-6 border md:border-l-0 lg:rounded-r-lg md:rounded-br-lg border-neutral-200 w-full lg-down:border-t-0 md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_15 = { class: "text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu")
], -1)
const _hoisted_18 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_19 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_20 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_21 = { class: "overflow-hidden sm:rounded-t-2xl" }
const _hoisted_22 = { class: "divide-y text-neutral-200" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-full",
      style: {"min-width":"160px"}
    }, " Nội dung ")
  ])
], -1)
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700 flex" }
const _hoisted_25 = { class: "ml-2" }
const _hoisted_26 = { class: "px-6 py-4 text-neutral-700" }
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = { class: "mr-2 hover:text-yellow-700 hover:underline" }
const _hoisted_29 = {
  key: 0,
  class: "flex gap-2 flex-wrap",
  style: {"max-width":"360px"}
}
const _hoisted_30 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap",
  style: {"font-size":"10px"}
}
const _hoisted_31 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_32 = { class: "mt-6" }
const _hoisted_33 = { class: "flex items-center justify-end md-down:flex-col md-down:items-end md-down:gap-4" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.7511 7.3111 8.68202 6.24922 7.87633 5.00267Z",
    fill: "#E5A42B"
  })
], -1)
const _hoisted_38 = { class: "py-12 flex items-center justify-between" }
const _hoisted_39 = { class: "text-3xl font-bold text-neutral-500 whitespace-nowrap md-down:text-xl" }
const _hoisted_40 = { class: "cursor-pointer" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.71478 8.71453C9.05649 8.37282 9.61051 8.37282 9.95221 8.71453L14.5835 13.3458L19.2148 8.71453C19.5565 8.37282 20.1105 8.37282 20.4522 8.71453C20.7939 9.05624 20.7939 9.61026 20.4522 9.95197L15.8209 14.5833L20.4522 19.2145C20.7939 19.5562 20.7939 20.1103 20.4522 20.452C20.1105 20.7937 19.5565 20.7937 19.2148 20.452L14.5835 15.8207L9.95221 20.452C9.61051 20.7937 9.05649 20.7937 8.71478 20.452C8.37307 20.1103 8.37307 19.5562 8.71478 19.2145L13.3461 14.5833L8.71478 9.95197C8.37307 9.61026 8.37307 9.05624 8.71478 8.71453Z",
  fill: "#94A3B8"
}, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "p-6 bg-white rounded-2xl" }
const _hoisted_44 = { class: "flex items-center justify-between mb-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Thống kê chung ", -1)
const _hoisted_46 = {
  key: 0,
  class: "font-semibold text-neutral-500 text-right"
}
const _hoisted_47 = { class: "grid grid-cols-1 md:grid-cols-3" }
const _hoisted_48 = { class: "p-3 border md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none" }
const _hoisted_49 = { class: "text-33 font-bold text-neutral-600 flex flex-nowrap items-center" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2 mb-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực ")
], -1)
const _hoisted_52 = { class: "p-3 border border-neutral-200 w-full md:border-l-0 md-down:border-t-0" }
const _hoisted_53 = { class: "text-33 font-bold text-neutral-600 mb-1 flex flex-nowrap items-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2 mb-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu")
], -1)
const _hoisted_56 = { class: "p-3 border border-neutral-200 w-full md:rounded-tr-lg md:border-l-0 md-down:border-t-0" }
const _hoisted_57 = { class: "text-33 font-bold text-neutral-600 mb-1 flex flex-nowrap items-center" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2 mb-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu lặp lại")
], -1)
const _hoisted_60 = { class: "p-3 border border-neutral-200 w-full border-t-0 md:rounded-bl-lg" }
const _hoisted_61 = { class: "text-33 font-bold text-neutral-600 mb-1 flex flex-nowrap items-center" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2 mb-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu mới")
], -1)
const _hoisted_64 = { class: "p-3 border border-neutral-200 w-full md:border-l-0 border-t-0" }
const _hoisted_65 = { class: "text-33 font-bold text-neutral-600 mb-1 flex flex-nowrap items-center" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2 mb-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Từ Ngân hàng MT")
], -1)
const _hoisted_68 = { class: "p-3 border border-t-0 md:border-l-0 md:rounded-br-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_69 = { class: "text-33 font-bold text-neutral-600 mb-1 flex flex-nowrap items-center" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2 mb-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Từ MT tạm dừng")
], -1)
const _hoisted_72 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_73 = { class: "bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md" }
const _hoisted_74 = { class: "relative" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "luca-logo",
    height: "24",
    width: "35"
  })
], -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-neutral-600 text-sm" }, " Chọn “Không dạy MT” hoặc “Xoá” để bỏ MT ra khỏi Kế hoạch này ", -1)
const _hoisted_77 = { class: "top-1 right-2 absolute cursor-pointer" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z",
  fill: "#E5A42B"
}, null, -1)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_81 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_82 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_83 = { class: "overflow-hidden sm:rounded-t-2xl" }
const _hoisted_84 = { class: "divide-y text-neutral-200" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-12 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-full",
      style: {"min-width":"160px"}
    }, " Nội dung ")
  ])
], -1)
const _hoisted_86 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700 flex" }
const _hoisted_87 = { class: "ml-2" }
const _hoisted_88 = { class: "px-6 py-4 text-neutral-700" }
const _hoisted_89 = { class: "flex items-center" }
const _hoisted_90 = ["innerHTML"]
const _hoisted_91 = {
  key: 0,
  class: "flex gap-2 flex-wrap",
  style: {"max-width":"360px"}
}
const _hoisted_92 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_93 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_94 = { class: "mt-6" }
const _hoisted_95 = {
  key: 0,
  class: "flex items-center justify-end md-down:flex-col md-down:items-end md-down:gap-4"
}
const _hoisted_96 = ["onClick"]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_98 = ["onClick"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("svg", {
  width: "9",
  height: "9",
  viewBox: "0 0 9 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.224562 0.224776C0.46864 -0.0193019 0.864368 -0.0193019 1.10845 0.224776L4.4165 3.53283L7.72456 0.224776C7.96864 -0.0193019 8.36437 -0.0193019 8.60845 0.224776C8.85252 0.468853 8.85252 0.864582 8.60845 1.10866L5.30039 4.41672L8.60845 7.72478C8.85252 7.96885 8.85252 8.36458 8.60845 8.60866C8.36437 8.85274 7.96864 8.85274 7.72456 8.60866L4.4165 5.3006L1.10845 8.60866C0.864368 8.85274 0.46864 8.85274 0.224562 8.60866C-0.0195155 8.36458 -0.0195155 7.96885 0.224562 7.72478L3.53262 4.41672L0.224562 1.10866C-0.0195155 0.864582 -0.0195155 0.468853 0.224562 0.224776Z",
    fill: "#E5A42B"
  })
], -1)
const _hoisted_100 = ["onClick"]
const _hoisted_101 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.7511 7.3111 8.68202 6.24922 7.87633 5.00267Z",
    fill: "#E5A42B"
  })
], -1)
const _hoisted_102 = {
  key: 1,
  class: "flex items-center justify-end md-down:flex-col md-down:items-end md-down:gap-4"
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.49634 6.03271C5.3599 6.03271 5.24752 5.92237 5.25511 5.78615C5.34964 4.09061 6.73831 3.5 8.00539 3.5C9.40188 3.5 10.6778 4.22998 10.6778 5.74072C10.6778 6.81982 10.043 7.33398 9.43361 7.79736C8.69729 8.35596 8.42434 8.56543 8.42434 9.28271V9.38818C8.42434 9.52625 8.31241 9.63818 8.17434 9.63818H7.36332C7.22658 9.63818 7.11521 9.52833 7.11334 9.39161L7.11037 9.1748C7.07229 8.24805 7.60549 7.67676 8.27834 7.18799C8.86867 6.74365 9.24318 6.45166 9.24318 5.81689C9.24318 4.9917 8.61477 4.64893 7.92922 4.64893C7.1265 4.64893 6.67618 5.12718 6.58723 5.78331C6.56868 5.92013 6.45889 6.03271 6.32082 6.03271H5.49634ZM7.82131 12.4756C7.23732 12.4756 6.81203 12.082 6.81203 11.5488C6.81203 10.9966 7.23732 10.6094 7.82131 10.6094C8.43068 10.6094 8.84963 10.9966 8.84963 11.5488C8.84963 12.082 8.43068 12.4756 7.82131 12.4756Z",
      fill: "#6390C3"
    })
  ])
], -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-lg" }, " Mục tiêu trong Kế hoạch hiện tại đã dạy thì không thể bị xóa khỏi Kế hoạch hiện tại ", -1)
const _hoisted_105 = {
  key: 1,
  class: "w-full px-6"
}
const _hoisted_106 = { class: "py-12 flex items-center justify-between" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl font-bold text-neutral-500 whitespace-nowrap" }, " Mục tiêu hoàn thành ", -1)
const _hoisted_108 = { class: "cursor-pointer" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.71478 8.71453C9.05649 8.37282 9.61051 8.37282 9.95221 8.71453L14.5835 13.3458L19.2148 8.71453C19.5565 8.37282 20.1105 8.37282 20.4522 8.71453C20.7939 9.05624 20.7939 9.61026 20.4522 9.95197L15.8209 14.5833L20.4522 19.2145C20.7939 19.5562 20.7939 20.1103 20.4522 20.452C20.1105 20.7937 19.5565 20.7937 19.2148 20.452L14.5835 15.8207L9.95221 20.452C9.61051 20.7937 9.05649 20.7937 8.71478 20.452C8.37307 20.1103 8.37307 19.5562 8.71478 19.2145L13.3461 14.5833L8.71478 9.95197C8.37307 9.61026 8.37307 9.05624 8.71478 8.71453Z",
  fill: "#94A3B8"
}, null, -1)
const _hoisted_110 = [
  _hoisted_109
]
const _hoisted_111 = { class: "p-6 bg-white rounded-2xl" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Thống kê chung ")
  ])
], -1)
const _hoisted_113 = { class: "grid grid-cols-1 md:grid-cols-2" }
const _hoisted_114 = { class: "p-3 border md:rounded-l-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none" }
const _hoisted_115 = { class: "text-33 font-bold text-neutral-600 flex flex-nowrap items-center" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2 mb-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số lĩnh vực ")
], -1)
const _hoisted_118 = { class: "p-3 border md-down:border-t-0 md:border-l-0 md:rounded-r-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none" }
const _hoisted_119 = { class: "text-33 font-bold text-neutral-600 mb-1 flex flex-nowrap items-center" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32",
  class: "mr-2 mb-2",
  style: {"height":"32px"}
}, null, -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng mục tiêu ")
], -1)
const _hoisted_122 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_123 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_124 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_125 = { class: "overflow-hidden sm:rounded-t-2xl" }
const _hoisted_126 = { class: "divide-y text-neutral-200" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-full",
      style: {"min-width":"160px"}
    }, " Nội dung ")
  ])
], -1)
const _hoisted_128 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_129 = { class: "ml-2" }
const _hoisted_130 = { class: "px-6 py-4 text-neutral-700" }
const _hoisted_131 = { class: "flex items-center" }
const _hoisted_132 = { class: "mr-2" }
const _hoisted_133 = {
  key: 0,
  class: "flex gap-2 flex-wrap",
  style: {"max-width":"360px"}
}
const _hoisted_134 = {
  key: 0,
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input",
  style: {"font-size":"10px"}
}
const _hoisted_135 = {
  class: "mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input",
  style: {"font-size":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteConfirm = _resolveComponent("DeleteConfirm")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_EditGoalForGroup = _resolveComponent("EditGoalForGroup")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TooltipGoalDetail = _resolveComponent("TooltipGoalDetail")!
  const _component_tamplete = _resolveComponent("tamplete")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalIsOpen) = $event)),
      onClose: _ctx.closeModelParent
    }, {
      default: _withCtx(() => [
        (_ctx.isReteach && !_ctx.isEditModal)
          ? (_openBlock(), _createBlock(_component_DeleteConfirm, {
              key: 0,
              successfully: _ctx.isSuccess,
              "onUpdate:successfully": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isSuccess) = $event)),
              "is-no-repeat": _ctx.isNoRepeatReTeach,
              "onUpdate:is-no-repeat": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isNoRepeatReTeach) = $event)),
              "is-re-teach": true,
              onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteGoal(_ctx.goalSelected))),
              onClose: _ctx.closeModal
            }, null, 8, ["successfully", "is-no-repeat", "onClose"]))
          : _createCommentVNode("", true),
        (!_ctx.isReteach && !_ctx.isEditModal)
          ? (_openBlock(), _createBlock(_component_DeleteConfirm, {
              key: 1,
              successfully: _ctx.isSuccess,
              "onUpdate:successfully": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isSuccess) = $event)),
              "is-no-repeat": _ctx.isNoRepeat,
              "onUpdate:is-no-repeat": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isNoRepeat) = $event)),
              onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteGoal(_ctx.goalSelected))),
              onClose: _ctx.closeModal
            }, null, 8, ["successfully", "is-no-repeat", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open", "onClose"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.isEditModal ? 'side-over--active' : '')
    }, [
      (_ctx.isEditModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isEditModal = false))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_EditGoalForGroup, {
        "is-group": true,
        show: _ctx.isEditModal,
        skills: _ctx.skills,
        "onUpdate:skills": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.skills) = $event)),
        data: _ctx.editData,
        "onUpdate:data": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editData) = $event)),
        error: _ctx.errorEdit,
        "onUpdate:error": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.errorEdit) = $event)),
        "tab-active": _ctx.tabActive,
        "onUpdate:tab-active": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tabActive) = $event)),
        onSubmit: _ctx.editSubmit,
        onClose: _ctx.closeModal
      }, null, 8, ["show", "skills", "data", "error", "tab-active", "onSubmit", "onClose"])
    ], 2),
    (_ctx.isCompleted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.type === 'library')
            ? (_openBlock(), _createBlock(_component_tamplete, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(), _createElementBlock("svg", {
                        width: "28",
                        height: "28",
                        viewBox: "0 0 28 28",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close')))
                      }, _hoisted_6))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.skills_count), 1)
                        ]),
                        _hoisted_13
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.goals_count), 1)
                        ]),
                        _hoisted_17
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals, (goal, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "my-10",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(index + 1) + ". " + _toDisplayString(goal.skill.name), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("table", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goal.goals, (g, i) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: g.id || g.goal_id,
                                      class: _normalizeClass([
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											, "text-neutral-700"])
                                    }, [
                                      _createElementVNode("td", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, _toDisplayString(i + 1), 1)
                                      ]),
                                      _createElementVNode("td", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                          _createVNode(_component_router_link, {
                                            to: `/group-class/${_ctx.id}/${
															g.goal_id || g.id
														}`
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_28, _toDisplayString(g.goal_name), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"]),
                                          _createVNode(_component_TooltipGoalDetail, {
                                            "is-group": true,
                                            "goal-id": 
															g.goal_id || g.id
														,
                                            "student-id": _ctx.id
                                          }, null, 8, ["goal-id", "student-id"])
                                        ]),
                                        (
														(g?.assistance_levels &&
															_ctx.org.enable_goal_assistance_level) ||
														g?.display_source
													)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                              (g?.display_source)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(g?.display_source), 1))
                                                : _createCommentVNode("", true),
                                              (
															g?.assistance_levels &&
															_ctx.org.enable_goal_assistance_level
														)
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(g?.assistance_levels, (ass) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: ass }, [
                                                      _createElementVNode("div", _hoisted_31, _toDisplayString(ass), 1)
                                                    ]))
                                                  }), 128))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("div", _hoisted_33, [
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (_ctx.deleting(g)),
                                              class: "cursor-pointer text-yellow-600 hover:text-yellow-700 font-semibold text-sm flex items-center md-down:items-right capitalize"
                                            }, [
                                              _hoisted_35,
                                              _createTextVNode(" XOÁ ")
                                            ], 8, _hoisted_34),
                                            _createElementVNode("div", {
                                              onClick: ($event: any) => (
																_ctx.editGoalModal(g)
															),
                                              class: "cursor-pointer text-yellow-600 hover:text-yellow-700 font-semibold text-sm flex items-center md-down:items-right whitespace-nowrap ml-6 capitalize"
                                            }, [
                                              _hoisted_37,
                                              _createTextVNode(" CHỈNH SỬA ")
                                            ], 8, _hoisted_36)
                                          ])
                                        ])
                                      ])
                                    ], 2))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, " Kế hoạch " + _toDisplayString(_ctx.report?.order), 1),
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(), _createElementBlock("svg", {
                      width: "28",
                      height: "28",
                      viewBox: "0 0 28 28",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close')))
                    }, _hoisted_42))
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      (_ctx.report?.applied_at)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, " Ngày áp dụng: " + _toDisplayString(_ctx.$filters.formatDate(_ctx.report?.applied_at)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createTextVNode(" " + _toDisplayString(_ctx.skills_count), 1)
                      ]),
                      _hoisted_51
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createTextVNode(" " + _toDisplayString(_ctx.goals_count), 1)
                      ]),
                      _hoisted_55
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createTextVNode(" " + _toDisplayString(_ctx.continued_goals_count), 1)
                      ]),
                      _hoisted_59
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        _createTextVNode(" " + _toDisplayString(_ctx.new_goals_count), 1)
                      ]),
                      _hoisted_63
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createTextVNode(" " + _toDisplayString(_ctx.goals_from_lib_count), 1)
                      ]),
                      _hoisted_67
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _hoisted_70,
                        _createTextVNode(" " + _toDisplayString(_ctx.goals_from_stopped_count), 1)
                      ]),
                      _hoisted_71
                    ])
                  ])
                ]),
                (_ctx.isShow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _hoisted_75,
                          _hoisted_76,
                          _createElementVNode("div", _hoisted_77, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isShow = false)),
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_79))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals, (goal, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "my-10",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_80, _toDisplayString(index + 1) + ". " + _toDisplayString(goal.skill.name) + " (" + _toDisplayString(goal.goals.length) + ") ", 1),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("table", _hoisted_84, [
                              _hoisted_85,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goal.goals, (g, i) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: g.goal_id,
                                    class: _normalizeClass([
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											, "text-neutral-700"])
                                  }, [
                                    _createElementVNode("td", _hoisted_86, [
                                      _createElementVNode("div", _hoisted_87, _toDisplayString(i + 1), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_88, [
                                      _createElementVNode("div", _hoisted_89, [
                                        _createVNode(_component_router_link, {
                                          to: `/group-class/${_ctx.id}/${
															g.goal_id || g.id
														}`
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", {
                                              class: "mr-2 hover:text-yellow-700 hover:underline",
                                              innerHTML: g.goal_name || g.name
                                            }, null, 8, _hoisted_90)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]),
                                        _createVNode(_component_TooltipGoalDetail, {
                                          "is-group": true,
                                          "goal-id": 
															g.goal_id || g.id
														,
                                          "student-id": _ctx.id
                                        }, null, 8, ["goal-id", "student-id"])
                                      ]),
                                      (
														(g?.assistance_levels &&
															_ctx.org.enable_goal_assistance_level) ||
														g?.display_source
													)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                            (g?.display_source)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(g?.display_source), 1))
                                              : _createCommentVNode("", true),
                                            (
															g?.assistance_levels &&
															_ctx.org.enable_goal_assistance_level
														)
                                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(g?.assistance_levels, (ass) => {
                                                  return (_openBlock(), _createElementBlock("div", { key: ass }, [
                                                    _createElementVNode("div", _hoisted_93, _toDisplayString(ass), 1)
                                                  ]))
                                                }), 128))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_94, [
                                        (g.editable)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                              (
																g.display_source ===
																	'new' &&
																g.editable
															)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.deleting(g)),
                                                    class: "cursor-pointer text-yellow-600 hover:text-yellow-700 font-semibold text-sm flex items-center md-down:items-right capitalize"
                                                  }, [
                                                    _hoisted_97,
                                                    _createTextVNode(" XOÁ ")
                                                  ], 8, _hoisted_96))
                                                : (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    onClick: ($event: any) => (
																_ctx.deleting(
																	g,
																	true
																)
															),
                                                    class: "cursor-pointer text-yellow-600 hover:text-yellow-700 font-semibold text-sm flex items-center md-down:items-right whitespace-nowrap ml-6"
                                                  }, [
                                                    _hoisted_99,
                                                    _createTextVNode(" KHÔNG DẠY MT ")
                                                  ], 8, _hoisted_98)),
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (
																_ctx.editGoalModal(g)
															),
                                                class: "cursor-pointer text-yellow-600 hover:text-yellow-700 font-semibold text-sm flex items-center md-down:items-right whitespace-nowrap ml-6 capitalize"
                                              }, [
                                                _hoisted_101,
                                                _createTextVNode(" CHỈNH SỬA ")
                                              ], 8, _hoisted_100)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                              _createVNode(_component_Popper, {
                                                placement: "top",
                                                hover: "",
                                                arrow: true
                                              }, {
                                                content: _withCtx(() => [
                                                  _hoisted_104
                                                ]),
                                                default: _withCtx(() => [
                                                  _hoisted_103
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                      ])
                                    ])
                                  ], 2))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ], 64))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_105, [
          _createElementVNode("div", _hoisted_106, [
            _hoisted_107,
            _createElementVNode("div", _hoisted_108, [
              (_openBlock(), _createElementBlock("svg", {
                width: "28",
                height: "28",
                viewBox: "0 0 28 28",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('close')))
              }, _hoisted_110))
            ])
          ]),
          _createElementVNode("div", _hoisted_111, [
            _hoisted_112,
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _hoisted_116,
                  _createTextVNode(" " + _toDisplayString(_ctx.skills_count__completed), 1)
                ]),
                _hoisted_117
              ]),
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("div", _hoisted_119, [
                  _hoisted_120,
                  _createTextVNode(" " + _toDisplayString(_ctx.goals_count__completed), 1)
                ]),
                _hoisted_121
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals__completed, (goal, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "my-10",
                key: index
              }, [
                _createElementVNode("div", _hoisted_122, _toDisplayString(index + 1) + ". " + _toDisplayString(goal.skill.name) + " (" + _toDisplayString(goal.goals.length) + ") ", 1),
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("table", _hoisted_126, [
                        _hoisted_127,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goal.goals, (g, i) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: g.id || g.goal_id,
                              class: _normalizeClass([
											i % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										, "text-neutral-700"])
                            }, [
                              _createElementVNode("td", _hoisted_128, [
                                _createElementVNode("div", _hoisted_129, _toDisplayString(i + 1), 1)
                              ]),
                              _createElementVNode("td", _hoisted_130, [
                                _createElementVNode("div", _hoisted_131, [
                                  _createVNode(_component_router_link, {
                                    to: `/goal/${_ctx.id}/${g.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_132, _toDisplayString(g.name ||
															g.goal_name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _createVNode(_component_TooltipGoalDetail, {
                                    "is-group": true,
                                    "goal-id": g.goal_id || g.id,
                                    "student-id": _ctx.id
                                  }, null, 8, ["goal-id", "student-id"])
                                ]),
                                (
													(g?.assistance_levels &&
														_ctx.org.enable_goal_assistance_level) ||
													g?.display_source
												)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                      (g?.display_source)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString(g?.display_source), 1))
                                        : _createCommentVNode("", true),
                                      (
														g?.assistance_levels &&
														_ctx.org.enable_goal_assistance_level
													)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(g?.assistance_levels, (ass) => {
                                            return (_openBlock(), _createElementBlock("div", { key: ass }, [
                                              _createElementVNode("div", _hoisted_135, _toDisplayString(ass), 1)
                                            ]))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
  ], 64))
}